import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { EasmScanConfigurationDataProviderFactory } from '../factory/EasmScanConfigurationDataProviderFactory';
import { EasmScanConfigurationBaseDataProvider } from '../dataProvider/EasmScanConfigurationBaseDataProvider';

export class EasmScanConfigurationRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmScanConfigurationDataProviderFactory;
  public dataProvider: EasmScanConfigurationBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EasmScanConfigurationDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<any> {
    return this.dataProvider.getDataForView();
  }
}
